type MastercardCardProps = Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> & {
  size: number;
};

export const MastercardCard = ({ size, ...props }: MastercardCardProps) => {
  const height = Math.round(size * 0.625); // Credit card aspect ratio

  return (
    <svg
      {...props}
      width={size}
      height={height}
      viewBox="0 0 120 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="120" height="80" rx="4" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.5288 54.6562V53.7384H97.289L97.0137 54.3698L96.7378 53.7384H96.498V54.6562H96.6675V53.9637L96.9257 54.5609H97.1011L97.36 53.9624V54.6562H97.5288ZM96.0111 54.6562V53.8947H96.318V53.7397H95.5361V53.8947H95.843V54.6562H96.0111Z"
        fill="#F79E1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.6521 58.595H70.3479V21.4044H49.6521V58.595Z"
        fill="#FF5F00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.2675 40.0003C98.2675 53.063 87.6791 63.652 74.6171 63.652C69.0996 63.652 64.0229 61.7624 60 58.5956C65.5011 54.2646 69.0339 47.5448 69.0339 40.0003C69.0339 32.4552 65.5011 25.7354 60 21.4044C64.0229 18.2376 69.0996 16.348 74.6171 16.348C87.6791 16.348 98.2675 26.937 98.2675 40.0003Z"
        fill="#F79E1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.966 40.0003C50.966 32.4552 54.4988 25.7354 59.9999 21.4044C55.977 18.2376 50.9003 16.348 45.3828 16.348C32.3208 16.348 21.7324 26.937 21.7324 40.0003C21.7324 53.063 32.3208 63.652 45.3828 63.652C50.9003 63.652 55.977 61.7624 59.9999 58.5956C54.4988 54.2646 50.966 47.5448 50.966 40.0003Z"
        fill="#EB001B"
      />
    </svg>
  );
};
